import { createSlice } from "@reduxjs/toolkit";

const emptyDuplicatesState = {
  records: [],
  groups: [],
  loading: false,
  lastFetchedAt: null,
};

export const companiesPageSlice = createSlice({
  name: "companiesPageState",
  initialState: {
    filtersCompanies: {
      page: 1,
      sortFilter: "company_number",
      sortAscending: true,
      searchWord: "",
      cityFilter: "",
    },
    companiesList: [],
    companyFunctions: [],
    duplicates: { ...emptyDuplicatesState },
  },
  reducers: {
    updateFilters: (state, action) => {
      state.filtersCompanies = action.payload;
    },
    updateCompaniesList: (state, action) => {
      const companiesList = action.payload;
    
      // Check if companiesList is an array
      if (Array.isArray(companiesList)) {
        state.companiesList = companiesList;
      } else {
        state.companiesList = []; // Set to an empty array if not an array
      }
    },
    updateDuplicates: (state, action) => {
      const payload = action.payload || {};
      if (!state.duplicates) state.duplicates = { ...emptyDuplicatesState };
      state.duplicates.records = Array.isArray(payload.records) ? payload.records : [];
      state.duplicates.groups = Array.isArray(payload.groups) ? payload.groups : [];
      state.duplicates.lastFetchedAt = payload.lastFetchedAt || Date.now();
    },
    setDuplicatesLoading: (state, action) => {
      if (!state.duplicates) state.duplicates = { ...emptyDuplicatesState };
      state.duplicates.loading = !!action.payload;
    },
    resetStateCompaniesPage: (state) => {
      state.filtersCompanies = {
        page: 1,
        sortFilter: "company_number",
        sortAscending: true,
        searchWord: "",
        cityFilter: "",
      };
      state.companiesList = [];
      state.companyFunctions = [];
      state.duplicates = { ...emptyDuplicatesState };
    },
    updateCompanyFunctions: (state, action) => {
      state.companyFunctions = action.payload;
    },
  },
})

export const { updateFilters, updateCompaniesList, updateDuplicates, setDuplicatesLoading, resetStateCompaniesPage, updateCompanyFunctions } = companiesPageSlice.actions
export default companiesPageSlice.reducer
